import { FlowService } from '../../../services';
import { useGetIntegratedPartnerId } from '../../Shared/hooks';

const useGetPageTitle = () => {
  const integratedPartnerId = useGetIntegratedPartnerId();
  const isCheckBusiness = FlowService.isCheckBusiness();

  if (integratedPartnerId) return 'package_free_page_title';
  return isCheckBusiness ? 'package_business_page_title' : 'package_page_title';
};

export default useGetPageTitle;
